module.exports = __webpack_public_path__ + "static/media/story-25.cd519252.png";